import { Routes, Router } from "@angular/router";
import { OktaAuthGuard } from "@tmhcc-ng-lib/framwork/okta-login";
export function onAuthRequired(oktaAuth, injector) {
  // Redirect the user to your custom login page
  const router = injector.get(Router);
  router.navigate(["/login"]);
}

const routes: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then(m => m.DashboardModule),
    // canActivate: [PreloadMasterDataGuard]
    //canActivate: [OktaAuthGuard, PreloadMasterDataGuard],
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },  
  {
    path: "subjectivity",
    loadChildren: () =>
      import("./quote/subjectivity/subjectivity.module").then(
        m => m.SubjectivityModule
      ),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  }, 
  {
    path: "document",
    loadChildren: () =>
      import("./quote/document/document.module").then(m => m.DocumentModule),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: "knr-dashboard",
    loadChildren: () =>
      import("./knr-dashboard/knr-dashboard.module").then(m => m.KnrDashboardModule),    
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: "wuw-dashboard",
    loadChildren: () =>
      import("./wuw-dashboard/wuw-dashboard.module").then(m => m.WUWDashboardModule),    
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired
    }
  }  
];

export const EcoRoutes = routes;
